import { FieldLabels } from '../../../../../../../../Model/CoachInfo';

const texts = {
  months: 'Months',
  price: 'Price',
  comments: 'Comments',
  assignedCAM: 'Assigned CAM:',
  emptyValue: '-',
  isEnrolledAt: 'IS Enrolled At:',
  fieldLabels: {
    [FieldLabels.CoachName]: 'Coach Name',
    [FieldLabels.CoachNamePronunciation]: 'Pronunciation',
    [FieldLabels.CoachLocation]: 'Location',
    [FieldLabels.SpecificRequirements]: 'Specific requirements',
    [FieldLabels.TrainingProgramme]: 'Training Programme',
    [FieldLabels.NutritionPlan]: 'Nutrition Plan',
    [FieldLabels.PointOfContact]: 'Point of contact',
    [FieldLabels.ResponseTime]: 'Response time in chat',
    [FieldLabels.ValuesAndBeliefs]: 'Values and beliefs',
    [FieldLabels.EducationAndQualification]: 'Education and qualification',
    [FieldLabels.ClientRequirementsAccepts]: 'Client requirements - Accepts',
    [FieldLabels.ClientRequirementsDoesNotAccept]: 'Client requirements - Does not accept',
    [FieldLabels.Personas]: 'Personas',
    [FieldLabels.ContactEmail]: 'Contact email',
    [FieldLabels.WebsiteURL]: 'Website URL',
    [FieldLabels.Instagram]: 'Instagram',
    [FieldLabels.Tiktok]: 'Tiktok',
    [FieldLabels.Pricing]: 'Pricing',
  },
};

export default texts;
